export default __webpack_public_path__ + "static/nimbus_bold-cc8e5655205b401416c88214f79daf1a.woff";